












































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { PriceOptimizerUnit } from "@/models";
import PriceOptimizerModule from "@/store/modules/price-optimizer";

const priceOptimizer = namespace(PriceOptimizerModule.name);

@Component({
  name: "QueueDisplay"
})
export default class QueueDisplay extends Vue {
  // ===== Store ===== //
  @priceOptimizer.Action private deletePriceChange!: (priceChangeId: number) => void;

  // ===== Props ===== //
  @Prop({ required: true }) private readonly unit!: PriceOptimizerUnit;
  @Prop({ required: true }) private readonly index!: number;
  @Prop(String) private readonly queuedStatus?: string;
  // ===== Data ===== //
  public deleteQueued = false;

  // ===== Methods ===== //
  private async handleDelete(unit: PriceOptimizerUnit): Promise<void> {
    unit.locked = true;
    this.deleteQueued = false;
    await this.deletePriceChange(unit.price_change_data.id);
    await this.$emit("changeDeleted");
  }
}
